import { GetStaticProps } from "next"
import { Box, Container, Grid } from "@mui/material"

import BreadCrumbs, { BreadCrumbAncestor } from "components/BreadCrumbs"

import useTranslation from "hooks/useTranslation"

import { getServerTranslations } from "utils/i18n/getServerTranslations"
import { helpCenterBreadCrumb } from "./index"

const ReturnShipment = () => {
	const { t } = useTranslation("help")

	const breadCrumb: BreadCrumbAncestor = {
		label: "Rücksendung & Widerrufsbelehrung",
		href: "/help/return-shipment",
	}

	return (
		<Box my={5}>
			<Box style={{ marginTop: "-40px", paddingBottom: "20px" }}>
				<BreadCrumbs
					breadCrumbsPaths={[
						{ ...helpCenterBreadCrumb, label: t(helpCenterBreadCrumb.label) },
					]}
					currentPath={breadCrumb}
				/>
			</Box>
			<Container>
				<Box
					pt={5}
					pb={2}
					style={{ textAlign: "center", maxWidth: "650px", margin: "auto" }}
				>
					<h1>Widerrufsbelehrung für Verträge über Waren</h1>
				</Box>
				<Grid container spacing={3}>
					<Grid item xs={12} md={12}>
						<div
							style={{
								borderBottom: "1px solid lightgrey",
								paddingBottom: "5px",
							}}
							className="h2"
						>
							<span style={{ borderBottom: "6px solid #7abfac" }}>
								Widerrufsrecht
							</span>
						</div>
						<p style={{ color: "grey" }}>
							Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen
							diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage
							ab dem Tag an dem Sie oder ein von Ihnen benannter Dritter, der nicht
							der Beförderer ist, die Waren in Besitz genommen haben bzw. hat.
						</p>
					</Grid>

					<Grid item xs={12} sm={12}>
						<p>
							Um Ihr Widerrufsrecht auszuüben, müssen Sie uns{" "}
							<strong>
								(secureo GmbH, Im Moos 19, 6067 Absam, Telefonnummer: 0512932791,
								E-Mail-Adresse: office@secureo.at)
							</strong>{" "}
							mittels einer eindeutigen Erklärung (z.B. ein mit der Post versandter
							Brief oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen,
							informieren. Sie können dafür das beigefügte Muster-Widerrufsformular
							verwenden, das jedoch nicht vorgeschrieben ist.
						</p>
						<p>
							Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung
							über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist
							absenden.
						</p>
					</Grid>
				</Grid>
				<Box my={5}>
					<div
						style={{
							borderBottom: "1px solid lightgrey",
							paddingBottom: "5px",
						}}
						className="h2"
					>
						<span style={{ borderBottom: "6px solid #7abfac" }}>
							Folgen des Widerrufs
						</span>
					</div>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<p>
								Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen,
								die wir von Ihnen erhalten haben, einschließlich der Lieferkosten
								(mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass
								Sie eine andere Art der Lieferung als die von uns angebotene,
								günstigste Standardlieferung gewählt haben), unverzüglich und
								spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem
								die Mitteilung über Ihren Widerruf dieses Vertrags bei uns
								eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe
								Zahlungsmittel, das Sie bei der ursprünglichen Transaktion
								eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas
								anderes vereinbart; in keinem Fall werden Ihnen wegen dieser
								Rückzahlung Entgelte berechnet. Wir können die Rückzahlung
								verweigern, bis wir die Waren wieder zurückerhalten haben oder bis
								Sie den Nachweis erbracht haben, dass Sie die Waren zurückgesandt
								haben, je nachdem, welches der frühere Zeitpunkt ist.
							</p>

							<p>
								Sie haben die Waren unverzüglich und in jedem Fall spätestens binnen
								vierzehn Tagen ab dem Tag, an dem Sie uns über den Widerruf dieses
								Vertrags unterrichten, an uns zurückzusenden oder zu übergeben. Die
								Frist ist gewahrt, wenn Sie die Waren vor Ablauf der Frist von
								vierzehn Tagen absenden. Wir tragen die Kosten der Rücksendung der
								Waren, die normal mit der Post zurückgesandt werden können. Sie
								tragen die unmittelbaren Kosten der Rücksendung der Waren, die
								aufgrund ihrer Beschaffenheit nicht normal mit der Post
								zurückgesandt werden können. Bei Waren, die aufgrund ihrer
								Beschaffenheit nicht normal mit der Post zurückgesandt werden
								können, betragen diese höchstens 80 € EUR. Sie müssen für einen
								etwaigen Wertverlust der Waren nur aufkommen, wenn dieser
								Wertverlust auf einen zur Prüfung der Beschaffenheit, Eigenschaften
								und Funktionsweise der Waren nicht notwendigen Umgang mit ihnen
								zurückzuführen ist.
							</p>
						</Grid>
					</Grid>
				</Box>
				<Box my={5}>
					<div
						style={{
							borderBottom: "1px solid lightgrey",
							paddingBottom: "5px",
						}}
						className="h2"
					>
						<span style={{ borderBottom: "6px solid #7abfac" }}>
							Muster-Widerrufsformular
						</span>
					</div>
					<div style={{ color: "grey" }}>
						(Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses
						Formular aus und senden Sie es zurück.)
					</div>
					<p>
						- An secureo GmbH, Im Moos 19, 6067 Absam, E-Mail-Adresse: office@secureo.at
						:
					</p>
					<p>
						- Hiermit widerrufe(n) ich/ wir (*) den von mir/ uns (*) abgeschlossenen
						Vertrag über den Kauf der folgenden Waren (*)/ <br />
						die Erbringung der folgenden Dienstleistung (*)
					</p>
					<p>- Bestellt am (*)/ erhalten am (*)</p>
					<p>
						- Name des/ der Verbraucher(s) <br />- Anschrift des/ der Verbraucher(s){" "}
						<br />- Unterschrift des/ der Verbraucher(s) (nur bei Mitteilung auf Papier)
						<br />- Datum
					</p>
					<p>(*) Unzutreffendes streichen.</p>
				</Box>
				<Box my={5}>
					<div
						style={{
							borderBottom: "1px solid lightgrey",
							paddingBottom: "5px",
						}}
						className="h2"
					>
						<span style={{ borderBottom: "6px solid #7abfac" }}>
							Besondere Hinweise
						</span>
					</div>
					<p>
						Wenn Sie diesen Vertrag durch ein Darlehen finanzieren und ihn später
						widerrufen, sind sie auch an den Darlehensvertrag nicht mehr gebunden,
						sofern beide Verträge eine wirtschaftliche Einheit bilden. Dies ist
						insbesondere dann anzunehmen, wenn wir gleichzeitig Ihr Darlehensgeber sind
						oder wenn sich Ihr Darlehensgeber im Hinblick auf die Finanzierung unserer
						Mitwirkung bedient. Wenn uns das Darlehen bei Wirksamwerden des Widerrufs
						bereits zugeflossen ist, tritt Ihr Darlehensgeber im Verhältnis zu Ihnen
						hinsichtlich der Rechtsfolgen des Widerrufs oder der Rückgabe in unsere
						Rechte und Pflichten aus dem finanzierten Vertrag ein. Letzteres gilt nicht,
						wenn der vorliegende Vertrag den Erwerb von Finanzinstrumenten (z.B. von
						Wertpapieren, Devisen oder Derivaten) zum Gegenstand hat.
					</p>
					<p>
						Wollen Sie eine vertragliche Bindung so weitgehend wie möglich vermeiden,
						machen Sie von Ihrem Widerrufsrecht Gebrauch und widerrufen Sie zudem den
						Darlehensvertrag, wenn Ihnen auch dafür ein Widerrufsrecht zusteht.
					</p>
				</Box>
			</Container>
			<Container>
				<Box
					pt={5}
					pb={2}
					style={{ textAlign: "center", maxWidth: "650px", margin: "auto" }}
				>
					<h1>Widerrufsbelehrung für Verträge über digitale Inhalte</h1>
				</Box>
				<Grid container spacing={3}>
					<Grid item xs={12} md={12}>
						<div
							style={{
								borderBottom: "1px solid lightgrey",
								paddingBottom: "5px",
							}}
							className="h2"
						>
							<span style={{ borderBottom: "6px solid #7abfac" }}>
								Widerrufsrecht
							</span>
						</div>
						<p style={{ color: "grey" }}>
							Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen
							diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage
							ab dem Tag des Vertragsabschlusses.{" "}
						</p>
					</Grid>

					<Grid item xs={12} sm={12}>
						<p>
							Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (Secureo GmbH, Im Moos
							19, 6067 Absam, Österreich, office@secureo.at, Telefon: +43 512 932791)
							mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter
							Brief, Telefax oder E-Mail) über Ihren Entschluss, diesen Vertrag zu
							widerrufen, informieren. Sie können dafür das beigefügte
							Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.{" "}
						</p>
						<p>
							Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung
							über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist
							absenden.
						</p>
					</Grid>
				</Grid>
				<Box my={5}>
					<div
						style={{
							borderBottom: "1px solid lightgrey",
							paddingBottom: "5px",
						}}
						className="h2"
					>
						<span style={{ borderBottom: "6px solid #7abfac" }}>
							Folgen des Widerrufs
						</span>
					</div>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<p>
								Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen,
								die wir von Ihnen erhalten haben, einschließlich der Lieferkosten
								(mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass
								Sie eine andere Art der Lieferung als die von uns angebotene,
								günstigste Standardlieferung gewählt haben), unverzüglich und
								spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem
								die Mitteilung über Ihren Widerruf dieses Vertrags bei uns
								eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe
								Zahlungsmittel, das Sie bei der ursprünglichen Transaktion
								eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas
								anderes vereinbart; in keinem Fall werden Ihnen wegen dieser
								Rückzahlung Entgelte berechnet.
							</p>
						</Grid>
					</Grid>
				</Box>
				<div
					style={{
						borderBottom: "1px solid lightgrey",
						paddingBottom: "5px",
					}}
					className="h2"
				>
					<span style={{ borderBottom: "6px solid #7abfac" }}>
						Ausschluss- bzw. Erlöschensgründe
					</span>
				</div>
				<div style={{ color: "grey" }}>
					(Das Widerrufsrecht besteht nicht bei Verträgen)
				</div>
				<Box mt={3}>
					- zur Lieferung von Waren, die nicht vorgefertigt sind und für deren Herstellung
					eine individuelle Auswahl oder Bestimmung durch den Verbraucher maßgeblich ist
					oder die eindeutig auf die persönlichen Bedürfnisse des Verbrauchers
					zugeschnitten sind. Insbesondere gilt dies für Schließanlagen, Profilzylinder in
					Gleichschließung, Nachlieferungen von Nachschlüsseln und Profilzylindern auf
					bestehende Schließungen, die auf Kundenwunsch angefertigt wurden. Der Kunde
					tätigt eine individuelle Auswahl, sobald er von den Voreinstellungen auf der
					jeweiligen Produktseite abweicht.
				</Box>
				<div>
					- zur Lieferung von Waren, die schnell verderben können oder deren Verfallsdatum
					schnell überschritten würde;
				</div>
				<div>
					- zur Lieferung alkoholischer Getränke, deren Preis bei Vertragsschluss
					vereinbart wurde, die aber frühestens 30 Tage nach Vertragsschluss geliefert
					werden können und deren aktueller Wert von Schwankungen auf dem Markt abhängt,
					auf die der Unternehmer keinen Einfluss hat;
				</div>
				<div>
					- zur Lieferung von Zeitungen, Zeitschriften oder Illustrierten mit Ausnahme von
					Abonnement-Verträgen.
				</div>
				<Box my={3}>
					<p>Das Widerrufsrecht erlischt vorzeitig bei Verträgen</p>
				</Box>
				<div>
					- zur Lieferung versiegelter Waren, die aus Gründen des Gesundheitsschutzes oder
					der Hygiene nicht zur Rückgabe geeignet sind, wenn ihre Versiegelung nach der
					Lieferung entfernt wurde;
				</div>
				<div>
					- zur Lieferung von Waren, wenn diese nach der Lieferung aufgrund ihrer
					Beschaffenheit untrennbar mit anderen Gütern vermischt wurden. Dies umfasst
					ebenfalls die unwiderrufliche Vermischung von Gütern, die durch die
					Inbetriebnahme und/oder Programmierung entstehen kann.
				</div>
				<div>
					- zur Lieferung von Waren, wenn diese nach der Lieferung aufgrund ihrer
					Beschaffenheit untrennbar mit anderen Gütern vermischt wurden;
				</div>
				<div>
					- zur Lieferung von Ton- oder Videoaufnahmen oder Computersoftware in einer
					versiegelten Packung, wenn die Versiegelung nach der Lieferung entfernt wurde.
				</div>
				<Box my={3}>
					<p>Allgemeine Hinweise zum Widerruf</p>
				</Box>
				<p>
					1) Bitte vermeiden Sie Beschädigungen und Verunreinigungen der Ware. Senden Sie
					die Ware bitte in Originalverpackung mit sämtlichem Zubehör und mit allen
					Verpackungsbestandteilen an uns zurück. Verwenden Sie bitte eine schützende
					Umverpackung. Wenn Sie die Originalverpackung nicht mehr besitzen, sorgen Sie
					bitte mit einer geeigneten Verpackung für einen ausreichenden Schutz vor
					Transportschäden.1) Bitte vermeiden Sie Beschädigungen und Verunreinigungen der
					Ware. Senden Sie die Ware bitte in Originalverpackung mit sämtlichem Zubehör und
					mit allen Verpackungsbestandteilen an uns zurück. Verwenden Sie bitte eine
					schützende Umverpackung. Wenn Sie die Originalverpackung nicht mehr besitzen,
					sorgen Sie bitte mit einer geeigneten Verpackung für einen ausreichenden Schutz
					vor Transportschäden.
				</p>
				<p>2) Senden Sie die Ware bitte nicht unfrei an uns zurück.</p>
				<p>
					3) Bitte beachten Sie, dass die vorgenannten Ziffern 1-2 nicht Voraussetzung für
					die wirksame Ausübung des Widerrufsrechts sind.
				</p>
				<Box my={5}>
					<div
						style={{
							borderBottom: "1px solid lightgrey",
							paddingBottom: "5px",
						}}
						className="h2"
					>
						<span style={{ borderBottom: "6px solid #7abfac" }}>
							Muster-Widerrufsformular
						</span>
					</div>
					<div style={{ color: "grey" }}>
						(Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses
						Formular aus und senden Sie es zurück.)
					</div>
					<p>
						- An secureo GmbH, Im Moos 19, 6067 Absam, E-Mail-Adresse: office@secureo.at
						:
					</p>
					<p>
						- Hiermit widerrufe(n) ich/ wir (*) den von mir/ uns (*) abgeschlossenen
						Vertrag über den Kauf der folgenden Waren (*)/ <br />
						die Erbringung der folgenden Dienstleistung (*)
					</p>
					<p>- Bestellt am (*)/ erhalten am (*)</p>
					<p>
						- Name des/ der Verbraucher(s) <br />- Anschrift des/ der Verbraucher(s){" "}
						<br />- Unterschrift des/ der Verbraucher(s) (nur bei Mitteilung auf Papier)
						<br />- Datum
					</p>
					<p>(*) Unzutreffendes streichen.</p>
				</Box>
				<Box my={5}>
					<div
						style={{
							borderBottom: "1px solid lightgrey",
							paddingBottom: "5px",
						}}
						className="h2"
					>
						<span style={{ borderBottom: "6px solid #7abfac" }}>
							Besondere Hinweise
						</span>
					</div>
					<p>
						Wenn Sie diesen Vertrag durch ein Darlehen finanzieren und ihn später
						widerrufen, sind sie auch an den Darlehensvertrag nicht mehr gebunden,
						sofern beide Verträge eine wirtschaftliche Einheit bilden. Dies ist
						insbesondere dann anzunehmen, wenn wir gleichzeitig Ihr Darlehensgeber sind
						oder wenn sich Ihr Darlehensgeber im Hinblick auf die Finanzierung unserer
						Mitwirkung bedient. Wenn uns das Darlehen bei Wirksamwerden des Widerrufs
						bereits zugeflossen ist, tritt Ihr Darlehensgeber im Verhältnis zu Ihnen
						hinsichtlich der Rechtsfolgen des Widerrufs oder der Rückgabe in unsere
						Rechte und Pflichten aus dem finanzierten Vertrag ein. Letzteres gilt nicht,
						wenn der vorliegende Vertrag den Erwerb von Finanzinstrumenten (z.B. von
						Wertpapieren, Devisen oder Derivaten) zum Gegenstand hat.{" "}
					</p>
					<p>
						Wollen Sie eine vertragliche Bindung so weitgehend wie möglich vermeiden,
						machen Sie von Ihrem Widerrufsrecht Gebrauch und widerrufen Sie zudem den
						Darlehensvertrag, wenn Ihnen auch dafür ein Widerrufsrecht zusteht.{" "}
					</p>
				</Box>
			</Container>
		</Box>
	)
}

export const getStaticProps: GetStaticProps = async (context) => {
	const props = {
		...(await getServerTranslations(context.locale, [
			"common",
			"countries",
			"languages",
			"help",
		])),
	}

	return {
		props,
	}
}

export default ReturnShipment
